import { render, staticRenderFns } from "./SignatureRequest.vue?vue&type=template&id=5ede8b18"
import script from "./SignatureRequest.vue?vue&type=script&lang=js"
export * from "./SignatureRequest.vue?vue&type=script&lang=js"
import style0 from "./SignatureRequest.vue?vue&type=style&index=0&id=5ede8b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports